<template>
  <div class="about" style="background:#fff;">
    <Banner image="guitarra-2" />
    <v-container>
      <h1 class="display-1 text-center my-6" data-aos="zoom-in">Contacto</h1>
      <v-row>
        <v-col cols="12" class="justify-center d-flex">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3870.218990327048!2d-75.73070682843846!3d-14.064241910104593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9110e2bdae3019ad%3A0xdc8edaf0195e4c53!2sPlaza%20de%20Armas%20de%20Ica%2C%20Ica%2011001!5e0!3m2!1ses-419!2spe!4v1571792815085!5m2!1ses-419!2spe" width="90%" height="400" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
        </v-col>
        <v-col class="content">
          <h3 class="headline mt-5" data-aos="zoom-in">Contactame...</h3>
          <v-col cols="6" class="py-0 px-0">
            <v-alert type="success" v-show="showMensaje" class="my-0">
            Mensaje enviado, recargando pagina.
          </v-alert>
          </v-col>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="6">
            <v-form  ref="form" v-model="valid" :action="url" method="POST" @submit="enviar" lazy-validation>
              <v-row>
                <v-col cols="12" xs="12"  sm="12" md="6" data-aos="fade-right"  data-aos-easing="ease-in-sine">
                 <v-text-field
                   v-model="name"
                   name="name"
                    label="Nombre"
                    outlined
                    hide-details
                    required
                  ></v-text-field>  
                </v-col>
                <v-col cols="12" xs="12" sm="12"  md="6" data-aos="fade-right"  data-aos-easing="ease-in-sine">
                  <v-text-field
                    v-model="email"
                    name="email"
                    label="Correo"
                    outlined
                    hide-details
                    requiredz
                  ></v-text-field>
                </v-col>
                <v-col cols="12" data-aos="fade-right"  data-aos-easing="ease-in-sine">
                  <v-text-field
                    v-model="asunto"
                    name="asunto"
                    label="Asunto"
                    outlined
                   hide-details
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" data-aos="fade-right"  data-aos-easing="ease-in-sine">
                  <v-textarea
                    v-model="message"
                    name="message"
                    label="Mensaje"
                    auto-grow
                    outlined
                    hide-details
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="justify-end d-flex" data-aos="fade-right"  data-aos-easing="ease-in-sine">
                  <v-btn outlined type="submit" :disabled="!valid" class="btn-submit">Enviar</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-col class="infor" cols="12" sm="12" md="6">
            <div class="infor-content" data-aos="fade-left"  data-aos-easing="ease-in-sine">
              <span><i class="fas fa-home"></i></span>
              <div>
                <h4 class="subtitle-1">Ica - Perú</h4>
                <p class="caption">La tinguiña</p>
              </div>
            </div>
            <div class="infor-content" data-aos="fade-left">
              <span><i class="fas fa-mobile-alt"></i></span>
              <div>
                <h4 class="subtitle-1">945 335 795</h4>
                <p class="caption">Horario</p>
              </div>
            </div>
            <div class="infor-content" data-aos="fade-left">
              <span><i class="fas fa-envelope"></i></span>
              <div>
                <h4 class="subtitle-1">genaropretill@gmail.com</h4>
                <p class="caption">Consultas</p>
              </div>
            </div>
          </v-col>
          </v-row>  
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Banner from '@/components/BannerBlog';
  export default {
    name:'contact',
    components:{Banner},
    data(){
      return {
        valid: true,
        name:'',
        email:'',
        asunto:'',
        message:'',
        showMensaje:false
      }
    },
    methods:{
     enviar(e){
       setTimeout(() => {
        e.preventDefault();
        this.name = '',
        this.email = '',
        this.asunto = '',
        this.message = '',
        this.showMensaje = true
      }, 2000);
      setTimeout(() => {
        e.preventDefault();
        window.location.reload()
      }, 4000);
      }
    },
    computed:{
      url(){
        return `${this.$store.state.baseURL}/api/send-email`
      }
    }
  }
</script>

<style lang="scss" scoped>
.infor{
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20%;
  &-content{
    display: flex;
    margin-bottom: 1.5rem;
    & span{
      margin-right: 1rem;
      width: 40px;
      text-align: center;
      & i {
        font-size: 1.8rem;
        color:#BDBDBD;
      }
    }
    & p {
      color:#757575;
    }
  }
}
.btn-submit{
  color:#2F1640 !important;
}
</style>
<style lang="scss">
[data-aos=zoom-in]{
  @media screen and (max-width:900px){
    transform:none !important;
  }
  
  }
[data-aos=fade-left]{
  @media screen and (max-width:900px){
    transform:none;
  }
  
}
[data-aos=fade-right]{
  @media screen and (max-width:900px){
    transform:none !important;
  }
  
  }
body[data-aos-easing="ease-in-sine"] [data-aos], [data-aos][data-aos][data-aos-easing="ease-in-sine"]{
  @media screen and (max-width:900px){
    transition-timing-function:none !important;
  }
  

}
[data-aos^='fade'][data-aos^='fade']{
  @media screen and (max-width:900px){
    opacity: 1;
  }
  
}
</style>